import { formatBytes } from "@gb/contracts";

/**
 * `2411724` → `"2.3 MB"`. Bytes stay bytes below 1 KB.
 *
 * The implementation is `formatBytes` in `@gb/contracts`, beside the byte limits
 * it renders — the phone held a character-for-character identical copy of it.
 * Re-exported under the console's own name so its importers are unchanged.
 */
export const formatSize = formatBytes;
